import { render } from "./ShowcaseFixzaem.vue?vue&type=template&id=82afecc2"
import script from "./ShowcaseFixzaem.vue?vue&type=script&lang=js"
export * from "./ShowcaseFixzaem.vue?vue&type=script&lang=js"

import "./ShowcaseFixzaem.vue?vue&type=style&index=0&id=82afecc2&lang=css"
import "./ShowcaseFixzaem.vue?vue&type=style&index=1&id=82afecc2&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-showcase/leadsbroker-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__